module.exports = {"share":{"rowsPerPage":"จำนวน","rangeSeparator":"จาก","noData":"ไม่มีข้อมูล"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/share.json
// module id = 546
// module chunks = 10